import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/serv/auth.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  constructor(private auth:AuthService) { }

  logOut(){
    this.auth.logoutwithgoogle();
  }
  ngOnInit(): void {
  }

}
